import { render, staticRenderFns } from "./message-icon.vue?vue&type=template&id=1e0c6ad0&"
import script from "./message-icon.vue?vue&type=script&lang=js&"
export * from "./message-icon.vue?vue&type=script&lang=js&"
import style0 from "./message-icon.vue?vue&type=style&index=0&id=1e0c6ad0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports